import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'retailer_mobile-bottom_nav-view';
/**
 * Retailer opens the nav and views it.
PRD - https:&#x2F;&#x2F;www.notion.so&#x2F;faire&#x2F;mWeb-bottom-nav-e289d4aa07d640bfa07019c14a532303
*/
export function trackRetailerMobileBottomNavView() {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
    });
}
